module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Upload-7f23e9067bb89ee78b471cf44cf8c195.svg";